import React, { useState } from "react";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";

/**
 * Carte repliable, REPLIÉE par défaut : un en-tête cliquable (titre, compteur, sous-titre) et un
 * corps qui n'est monté que déplié. Sert aux réglages secondaires d'une page (matrices de la page
 * Utilisateurs) pour qu'ils ne poussent pas le contenu principal hors de l'écran. Même grammaire
 * visuelle que la liste « En attente d'approbation » : chevron à droite, `aria-expanded` porté par
 * le bouton d'en-tête.
 */
export const CollapsibleCard: React.FC<{
	title: string;
	subtitle?: string;
	/** Pastille de comptage à côté du titre (ex. nombre de lignes visibles). */
	count?: number;
	/** Replié par défaut ; passer `true` n'a de sens que pour un panneau vraiment central. */
	defaultOpen?: boolean;
	children: React.ReactNode;
}> = ({ title, subtitle, count, defaultOpen = false, children }) => {
	const [open, setOpen] = useState(defaultOpen);
	return (
		<div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
			<button
				type="button"
				onClick={() => setOpen((v) => !v)}
				aria-expanded={open}
				className="flex w-full items-center justify-between gap-3 px-5 py-3.5 text-left transition hover:bg-slate-50"
			>
				<span className="min-w-0">
					<span className="flex items-center gap-2">
						<span className="text-sm font-bold uppercase tracking-wide text-slate-700">{title}</span>
						{typeof count === "number" && (
							<span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-bold text-slate-600">{count}</span>
						)}
					</span>
					{subtitle && <span className="mt-0.5 block text-xs text-slate-500">{subtitle}</span>}
				</span>
				{open ? <FiChevronUp className="h-4 w-4 shrink-0 text-slate-500" /> : <FiChevronDown className="h-4 w-4 shrink-0 text-slate-500" />}
			</button>
			{open && <div className="border-t border-slate-100 px-5 py-4">{children}</div>}
		</div>
	);
};

export default CollapsibleCard;
